import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd688c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-gap-3 tw-w-full" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-3 tw-w-full" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "modal-statement modal-content !tw-mb-[20px]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Please provide a reason for your extension request (Optional)", -1))
const _hoisted_9 = { class: "modal-footer" }

import { computed, onMounted, ref, watch } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DSPRequestExtensionModal',
  props: {
  disputeProject: {
    type: Object,
  },
  extensionRequested: {
    type: Boolean,
    default: false,
  },
},
  emits: ["on-close", "submit"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const description = ref<string>("");

// const validation = ref({
//   description: [(v: string) => !!v || "Enter Evidence description"],
// });

const selectedDay = ref<number>(1);
const days = ref([
  {
    id: 1,
    hours: "24",
  },
  {
    id: 2,
    hours: "48",
  },
  {
    id: 3,
    hours: "72",
  },
]);

const internalInstance = getCurrentInstance();

const disputeProject = computed(() => {
  return store.getters[`${PROJECT_STORE}/getDisputeProject`];
});

const toggleDayCard = (id: number) => {
  selectedDay.value = id;
};

const onRequestForExtension = async () => {
  try {
    const disputeIssueId = disputeProject.value.id;

    const payload = {
      days: selectedDay.value,
      description: description.value,
    };
    const request = {
      disputeIssueId,
      payload,
    };

    const response = await store.dispatch(
      `${PROJECT_STORE}/requestForExtension`,
      request
    );
    store.commit(`${PROJECT_STORE}/updateProjectDispute`, {
      extensionRequest: response.data ? [response.data] : [],
    });
    displayToastMessage(
      internalInstance,
      "Request Extension Successfully",
      "success"
    );
  } catch (error: any) {
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      console.log("error :>> ", error);
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    onClickBackButton();
  }
};

const onClickBackButton = () => {
  return emits("on-close");
};

onMounted(() => {
  const extensionRequest = disputeProject.value.extension_request.find(
    (request: any) => request.status === "pending"
  );

  if (extensionRequest) {
    description.value = extensionRequest.description;
    selectedDay.value = extensionRequest.days;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "20px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Request Extension",
    headerDescription: "You have the option to request an extension to submit your evidence. Please choose an extension time",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref: "formRef",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Text, {
                    variant: "h6",
                    textWeight: "400"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Select the length of extension you are seeking")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        onClick: ($event: any) => (toggleDayCard(day.id)),
                        key: index,
                        class: _normalizeClass(["tw-rounded-[8px] tw-border-[1px] tw-w-auto tw-border-solid tw-border-[#DFDFDF] tw-bg-[#F8FBFD] tw-p-2 tw-h-[44px] tw-box-border tw-flex tw-items-center tw-gap-2 tw-cursor-pointer", {
                      '!tw-border-[#3366FF] !tw-bg-[rgba(51,102,255,0.06)]':
                        selectedDay.value === day.id,
                    }])
                      }, [
                        _createVNode(Text, {
                          variant: "h6",
                          textWeight: "400"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(day.hours) + " Hours", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ], 10, _hoisted_6))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_v_textarea, {
                    class: "input_field",
                    placeholder: "Please type your statement here",
                    variant: "solo",
                    rows: "5",
                    "bg-color": "#f8fbfd",
                    autogrow: "",
                    modelValue: description.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
                    disabled: __props.extensionRequested
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }),
                (!__props.extensionRequested)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button button-purple",
                      onClick: onRequestForExtension
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Submit Extension Request ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 512)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})